import styled from 'styled-components';
var NotAllowedContainer = styled.div.withConfig({
  displayName: "NotAllowedstyle__NotAllowedContainer",
  componentId: "sc-1ddq776-0"
})(["text-align:center;"]);
export { NotAllowedContainer };